import { Injectable } from '@angular/core';
declare let $: any;
declare let iziToast: any;
@Injectable({
    providedIn: 'root'
})
export class ToasterService {
    type: any;
    position: any;
    icon: any;
    message: any;
    title: any;
    show = true;
    timeOut: any;
    constructor() { }
    setOptions(options: ToastOptions) {
        this.type = options.type;
        this.icon = options.icon;
        this.position = options.position;
        this.title = options.title;
        this.message = options.message;
        this.timeOut = options.timeOut || false;
        this.show = options.show || true;
    }
    onClick() {
        const $type = this.type,
            $icon = this.icon,
            $position = this.position,
            $title = this.title,
            $message = this.message,
            $timeOut = this.timeOut;
        let toastOptions = {};

        switch ($position) {
            case 'topRight':
                toastOptions = {
                    class: 'iziToast-' + $type || '',
                    title: $title || 'Title',
                    message: $message || 'toast message',
                    animateInside: false,
                    position: 'topRight',
                    progressBar: false,
                    icon: $icon,
                    timeout: $timeOut,
                    transitionIn: 'fadeInLeft',
                    transitionOut: 'fadeOut',
                    transitionInMobile: 'fadeIn',
                    transitionOutMobile: 'fadeOut'
                };
                break;
            case 'bottomRight':
                toastOptions = {
                    class: 'iziToast-' + $type || '',
                    title: $title || 'Title',
                    message: $message || 'toast message',
                    animateInside: false,
                    position: 'bottomRight',
                    progressBar: false,
                    icon: $icon,
                    timeout: $timeOut,
                    transitionIn: 'fadeInLeft',
                    transitionOut: 'fadeOut',
                    transitionInMobile: 'fadeIn',
                    transitionOutMobile: 'fadeOut'
                };
                break;
            case 'topLeft':
                toastOptions = {
                    class: 'iziToast-' + $type || '',
                    title: $title || 'Title',
                    message: $message || 'toast message',
                    animateInside: false,
                    position: 'topLeft',
                    progressBar: false,
                    icon: $icon,
                    timeout: $timeOut,
                    transitionIn: 'fadeInRight',
                    transitionOut: 'fadeOut',
                    transitionInMobile: 'fadeIn',
                    transitionOutMobile: 'fadeOut'
                };
                break;
            case 'bottomLeft':
                toastOptions = {
                    class: 'iziToast-' + $type || '',
                    title: $title || 'Title',
                    message: $message || 'toast message',
                    animateInside: false,
                    position: 'bottomLeft',
                    progressBar: false,
                    icon: $icon,
                    timeout: $timeOut,
                    transitionIn: 'fadeInRight',
                    transitionOut: 'fadeOut',
                    transitionInMobile: 'fadeIn',
                    transitionOutMobile: 'fadeOut'
                };
                break;
            case 'topCenter':
                toastOptions = {
                    class: 'iziToast-' + $type || '',
                    title: $title || 'Title',
                    message: $message || 'toast message',
                    animateInside: false,
                    position: 'topCenter',
                    progressBar: false,
                    icon: $icon,
                    timeout: $timeOut,
                    transitionIn: 'fadeInDown',
                    transitionOut: 'fadeOut',
                    transitionInMobile: 'fadeIn',
                    transitionOutMobile: 'fadeOut'
                };
                break;
            case 'bottomCenter':
                toastOptions = {
                    class: 'iziToast-' + $type || '',
                    title: $title || 'Title',
                    message: $message || 'toast message',
                    animateInside: false,
                    position: 'bottomCenter',
                    progressBar: false,
                    icon: $icon,
                    timeout: $timeOut,
                    transitionIn: 'fadeInUp',
                    transitionOut: 'fadeOut',
                    transitionInMobile: 'fadeIn',
                    transitionOutMobile: 'fadeOut'
                };
                break;
            default:
                toastOptions = {
                    class: 'iziToast-' + $type || '',
                    title: $title || 'Title',
                    message: $message || 'toast message',
                    animateInside: false,
                    position: 'topRight',
                    progressBar: false,
                    icon: $icon,
                    timeout: $timeOut,
                    transitionIn: 'fadeInLeft',
                    transitionOut: 'fadeOut',
                    transitionInMobile: 'fadeIn',
                    transitionOutMobile: 'fadeOut'
                };
        }
        // if (typeof this.show === 'boolean' && this.show === true) {
        window.scrollTo(0, 0);
        iziToast.show(toastOptions);
        // }
    }
    close() {

        if (iziToast.toast) {
            iziToast.hide({}, iziToast.toast);
        }

    }
    showAlways(options) {
        this.setOptions(options)
        this.onClick();

    }
    error(message: string, title?: string, position?: string, timeOut?: number) {
        this.setOptions({
            type: 'danger', position: position || 'topRight', icon: 'material-icons block',
            title: title || 'Error', message: message || '!!', timeOut: timeOut || 5000
        });
        this.onClick();

    }
    success(message: string, title?: string, position?: string, timeOut?: number) {
        this.setOptions({
            type: 'success', position: position || 'topRight', icon: 'material-icons check',
            title: title || 'SUCCESS', message: message || '!!', timeOut: timeOut || 5000
        });
        this.onClick();
    }
    warning(message: string, title?: string, position?: string, timeOut?: number) {
        this.setOptions({
            type: 'warning', position: position || 'topRight', icon: 'material-icons warning',
            title: title || 'WARNING', message: message || '!!', timeOut: timeOut || 5000
        });
        this.onClick();
    }
    info(message: string, title?: string, position?: string, timeOut?: number) {
        this.setOptions({
            type: 'info', position: position || 'topRight', icon: 'material-icons notifications_none',
            title: title || '', message: message || '!!', timeOut: timeOut || 5000
        });
        this.onClick();
    }

}

export interface ToastOptions {
    type: any;
    position: any;
    icon: any;
    message: any;
    title: any;
    show?: boolean;
    timeOut?: number;
}
